export default __webpack_public_path__ + "2a54e4db91e010f35b4300a4d27e7d9b.png";